import { networkType } from "../config";

export const addressMap = {
  testnet: {
    uSPONRedemption: "0x4D0FBda7AE028C8862Cb34dF3752CfcF91781fBa",
    escrow: "0x7d763d49481C1A3525591f33f9D94fAD220d5de7",
    uSPON: "0xeD8F325cDc2BA7567395cb451A2ea8FAf40E23D2",
    SPON: "0x76e593392523243ACD38ceD87c2007F14483a86B",
  },
  mainnet: {
    uSPONRedemption: "0xee1c4d80af9ab191f2ee9983ddbe8ba5e28505b0",
    escrow: "0x7381F084D31EF2F983c95572b7DD6Ee99eE03d8d",
    uSPON: "0xBf0fA0461331d815A103e59929E5a19A48C30f5e",
    SPON: "0x080D43c2164AFdBc3712422CE78Ab902ccaB5CA1",
  },
} as const;

export const uSPONRedemption = addressMap[networkType].uSPONRedemption;
export const escrow = addressMap[networkType].escrow;
export const uSPON = addressMap[networkType].uSPON;
export const SPON = addressMap[networkType].SPON;
